import React from 'react'
import PropTypes from 'prop-types'

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import { Box, TextField } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'

import { isCredibleDate } from 'common/date'

const invalidErrorTextId = `date-invalid-error-id-${Math.random().toString(36).substr(2, 9)}`
const minErrorTextId = `date-min-error-id-${Math.random().toString(36).substr(2, 9)}`
const maxErrorTextId = `date-max-error-id-${Math.random().toString(36).substr(2, 9)}`

const CustomTextField = (textFieldProps) => {
  const inputProps = {
    'aria-describedby': `${invalidErrorTextId} ${minErrorTextId} ${maxErrorTextId}`,
  }
  return (
    <TextField
      {...textFieldProps}
      inputProps={inputProps}
    />
  )
}

const CustomErrorText = ({ id, children }) => {
  return (
    <Box
      id={id}
      aria-live="polite"
      component="span"
      m={0}
    >
      {children}
    </Box>
  )
}

const DatePicker = ({ date, invalidDateMessage, minDateMessage, maxDateMessage, onChange, ...datePickerProps }) => {
  const value = isCredibleDate(date) ? date : null

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...datePickerProps}
        value={value}
        variant="inline"
        inputVariant="outlined"
        onChange={(updatedDate) => onChange(updatedDate)}
        TextFieldComponent={CustomTextField}
        invalidDateMessage={<CustomErrorText id={invalidErrorTextId}>{invalidDateMessage}</CustomErrorText>}
        minDateMessage={<CustomErrorText id={minErrorTextId}>{minDateMessage}</CustomErrorText>}
        maxDateMessage={<CustomErrorText id={maxErrorTextId}>{maxDateMessage}</CustomErrorText>}
      />
    </MuiPickersUtilsProvider>
  )
}

CustomErrorText.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
}

DatePicker.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  invalidDateMessage: PropTypes.string,
  minDateMessage: PropTypes.string,
  maxDateMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

DatePicker.defaultProps = {
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
}

export default DatePicker
